/**
 * `settings` — docs/SPEC.md, prototip 953–989.
 *
 * Uchta guruh: HISOB · MAXFIYLIK · ILOVA.
 *
 * Toggle'lar hozircha SERVERGA YOZILMAYDI — ular uchun endpoint yo'q
 * (`PATCH /me` da bunday maydonlar yo'q va o'zimdan qo'shmadim). Shuning
 * uchun ular o'chirilgan holatda va bosilganda izoh chiqadi: yolg'on ishlab
 * turgan tugmadan ko'ra ochiq "hali emas" yaxshiroq.
 */

import { useNavigate } from 'react-router-dom';

import { useBackButton } from '../app/useBackButton';
import { uz } from '../i18n/uz';
import { useMe } from '../lib/api/useMe';
import { fmt } from '../lib/format';
import { Icon, Toast, type IconName } from '../ui';
import { useToast } from '../ui/useToast';
import './screens.css';

const APP_VERSION = import.meta.env['VITE_APP_VERSION'] ?? '0.1.0';

interface Row {
  icon: IconName;
  color: string;
  name: string;
  /** Bosilganda qayerga. Berilmasa — "hali ochilmagan" izohi. */
  to?: string | undefined;
  /** `| undefined` ataylab — `exactOptionalPropertyTypes` yoqilgan. */
  value?: string | undefined;
}

export function Settings() {
  const navigate = useNavigate();
  const { data: me } = useMe();
  const toast = useToast();

  const goBack = () => navigate('/profile');
  useBackButton(true, goBack);

  const notYet = () => toast.show(uz.settings.notYet);

  const groups: { title: string; rows: Row[] }[] = [
    {
      title: uz.settings.groupAccount,
      rows: [
        {
          icon: 'user',
          color: 'var(--lavender)',
          name: uz.settings.editProfile,
          to: '/profile/edit',
        },
        {
          icon: 'gem',
          color: 'var(--gem)',
          name: uz.settings.wallet,
          to: '/shop',
          // Balans SERVERDAN — klientda qattiq yozilgan raqam yo'q (qoida 22).
          value: me ? fmt(me.gems) : undefined,
        },
        {
          icon: 'crown',
          color: 'var(--gold)',
          name: uz.settings.vip,
          to: '/shop',
          value: me?.vip ? me.vip.name : uz.settings.vipNone,
        },
      ],
    },
    {
      title: uz.settings.groupPrivacy,
      rows: [
        { icon: 'micoff', color: 'var(--coral)', name: uz.settings.quietJoin },
        { icon: 'eyeoff', color: 'var(--lavender)', name: uz.settings.hideOnline },
        { icon: 'shield', color: 'var(--pink)', name: uz.settings.blocked },
      ],
    },
    {
      title: uz.settings.groupApp,
      rows: [
        { icon: 'bell', color: 'var(--gold)', name: uz.settings.notifications },
        {
          icon: 'globe',
          color: 'var(--blue)',
          name: uz.settings.language,
          value: uz.settings.languageUz,
        },
        { icon: 'help', color: 'var(--fg-55)', name: uz.settings.help },
        // SPEC.md:321 — "Qo'shiladi: Offerta va maxfiylik siyosati (D-018)".
        // 16+ ilova uchun bu majburiy: foydalanuvchi nimaga rozi
        // bo'lganini istalgan vaqtda ko'ra olishi kerak.
        { icon: 'shield', color: 'var(--fg-55)', name: uz.settings.legal },
      ],
    },
    {
      title: uz.settings.groupDanger,
      rows: [
        // Hisobni o'chirish — SPEC.md:321. Endpoint hali yo'q, shuning
        // uchun hozircha `notYet`. Qatorni oldindan qo'yamiz: uni keyin
        // qo'shish "unutildi" bo'lib qolishi eng oson narsa, holbuki
        // ma'lumotni o'chirish talabi qonuniy (Q-035).
        { icon: 'close', color: 'var(--danger)', name: uz.settings.deleteAccount },
      ],
    },
  ];

  return (
    <div className="screen">
      {toast.message && <Toast message={toast.message} />}

      <div className="screen-bar" style={{ justifyContent: 'flex-start' }}>
        <button type="button" className="icon-btn" onClick={goBack} aria-label={uz.profile.title}>
          <Icon name="back" size={16} />
        </button>
        <h1 className="screen-bar__title">{uz.settings.title}</h1>
      </div>

      <div className="settings-groups">
        {groups.map((group) => (
          <div key={group.title}>
            <div className="settings-group__title">{group.title}</div>
            <div className="settings-group__body">
              {group.rows.map((row) => (
                <button
                  key={row.name}
                  type="button"
                  className="settings-row"
                  onClick={() => (row.to ? navigate(row.to) : notYet())}
                >
                  <Icon name={row.icon} size={17} color={row.color} />
                  <span className="settings-row__name">{row.name}</span>
                  <span className="settings-row__value">
                    {row.value !== undefined && <span className="tnum">{row.value}</span>}
                    <Icon name="right" size={13} color="var(--fg-28)" />
                  </span>
                </button>
              ))}
            </div>
          </div>
        ))}

        <div className="settings__version">{`Voice Rooms · ${APP_VERSION}`}</div>
      </div>
    </div>
  );
}
